import { useState, FormEventHandler } from 'react'

import { ReportFormatList } from '../report/list'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Stack,
  Tooltip,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
} from '@mui/material'

import { NumericInput } from 'components/controls/numbericInput'
import { Section } from 'components/controls/section'

import { OkIcon, CloseIcon } from 'shared/icons'

export type FormatTypes = 'csv' | 'tsv' | 'excel' | 'report'
export type ContentTypes = 'code' | 'name' | 'all'

type SisetuListDownloadDialogProps = {
  sisetuCount: number
  onDownload: (
    format: FormatTypes,
    content: ContentTypes,
    reportId: string | null,
    from: number,
    to: number
  ) => void
  onClose: () => void
}
export const SisetuListDownloadDialog = ({
  sisetuCount,
  onDownload,
  onClose
}: SisetuListDownloadDialogProps) => {
  const [format, setFormat] = useState<FormatTypes>('excel')
  const [content, setContent] = useState<ContentTypes>('code')
  const [reportId, setReportId] = useState<string | null>(
    ReportFormatList.length > 0 ? ReportFormatList[0].reportId : null
  )
  const [from, setFrom] = useState<string>('')
  const [to, setTo] = useState<string>(sisetuCount.toString())

  const onSubmitForm: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault()
    let nFrom = from.trim() === '' ? 0 : parseInt(from)
    if (nFrom < 0) nFrom = 0
    let nTo = to.trim() === '' ? sisetuCount : parseInt(to)
    if (nTo < 0) nTo = sisetuCount
    if (nFrom > nTo) return

    onDownload(format, content, reportId, nFrom, nTo)
  }
  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      onClose={() => {
        onClose()
      }}
    >
      <DialogTitle>
        <Stack direction="row" spacing={2}>
          <Typography variant="h5" color="text.primary" flexGrow={1}>
            ダウンロード
          </Typography>
          <Tooltip title="閉じる">
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </DialogTitle>

      <form onSubmit={onSubmitForm}>
        <DialogContent>
          <Stack direction="column">
            <FormControl>
              <Section label="形式" labelProps={{ paddingY: 2 }}>
                <RadioGroup
                  value={format}
                  name="download-format"
                  onChange={(e) => setFormat(e.target.value as FormatTypes)}
                >
                  <FormControlLabel
                    value="csv"
                    control={<Radio />}
                    label="CSV形式"
                  />
                  <FormControlLabel
                    value="tsv"
                    control={<Radio />}
                    label="TSV形式"
                  />
                  <FormControlLabel
                    value="excel"
                    control={<Radio />}
                    label="EXCEL形式"
                  />
                  <FormControlLabel
                    value="report"
                    control={<Radio />}
                    label="レポート"
                  />
                </RadioGroup>
              </Section>
            </FormControl>

            <FormControl>
              <Section label="内容" labelProps={{ paddingY: 2 }}>
                {format === 'report' ? (
                  <Select
                    id="targetList"
                    variant="outlined"
                    value={reportId}
                    onChange={(event) =>
                      setReportId(event.target.value as string)
                    }
                    size="small"
                  >
                    {ReportFormatList.map((reportFormat) => {
                      return (
                        <MenuItem
                          key={`reportFormat-${reportFormat.reportId}`}
                          value={reportFormat.reportId}
                        >
                          {reportFormat.reportName}
                        </MenuItem>
                      )
                    })}
                  </Select>
                ) : (
                  <RadioGroup
                    value={content}
                    name="download-content"
                    onChange={(e) => setContent(e.target.value as ContentTypes)}
                  >
                    <FormControlLabel
                      value="code"
                      control={<Radio />}
                      label="施設コードのみ"
                    />
                    <FormControlLabel
                      value="name"
                      control={<Radio />}
                      label="施設コードと施設名"
                    />
                    <FormControlLabel
                      value="all"
                      control={<Radio />}
                      label="すべての項目"
                    />
                  </RadioGroup>
                )}
              </Section>
            </FormControl>

            <FormControl>
              <Section label="対象範囲" labelProps={{ paddingY: 2 }}>
                <Stack direction="row" spacing={1}>
                  <NumericInput
                    state={from}
                    setState={setFrom}
                    label="from"
                  />
                  <NumericInput
                    state={to}
                    setState={setTo}
                    label="to"
                  />
                </Stack>
              </Section>
            </FormControl>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ padding: 2 }}>
          <Button variant="contained" type="submit" startIcon={<OkIcon />}>
            実 行
          </Button>
          <Button variant="text" onClick={onClose}>
            キャンセル
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
